import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TextField,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
//Icons
import SearchIcon from "@mui/icons-material/Search";
//Srcs
import "../Style/pagestyle.scss";
import "./setupfee.scss";
import CreateIcon from "../Assets/create-icon.svg";
import EmptyData from "../Components/Include/EmptyData";
import LoadingPage from "../Components/Include/LoadingPage";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "../Function/Translate";
import FooterPagination from "../Components/Include/FooterPagination";
import CreateSchoolFee from "../Components/SchoolFee/CreateSchoolFee";
import SchoolFeeAction from "../Components/SchoolFee/SchoolFeeAction";
import { GET_SCHOOL_FEE } from "../Schema/SchoolFees";

export default function SetUpFee() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(8);
  const [type, setType] = useState("All");

  const { refetch } = useQuery(GET_SCHOOL_FEE, {
    variables: {
      keyword: keyword,
      type: type,
    },
    onCompleted: ({ getSchoolFeesAccouting }) => {
      setTableData(getSchoolFeesAccouting);
      setPaginationData();
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    if (tableData?.length !== 0) {
      let refetchData = tableData?.filter((d) => d?.role === null);
      if (refetchData?.length !== 0) {
        refetch();
      }
    }
  }, [tableData]);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>

        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">{t("page_setting")}</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">School Fees</Typography>
        </Stack>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">School Fees</Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="search-head-title">
              {t("thead_search_name")}
            </Typography>

            <TextField
              placeholder={t("search")}
              size="small"
              className="search-field"
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "#0f81c2" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <Typography className="search-head-title">Type</Typography>
            <FormControl fullWidth size="small" className="search-field">
              <Select value={type} onChange={(e) => setType(e.target.value)}>
                <MenuItem value={"All"}>All</MenuItem>
                <MenuItem value={"AdminFee"}>Admin Fee</MenuItem>
                <MenuItem value={"Material"}>Material</MenuItem>
                <MenuItem value={"Tuition"}>Tuition</MenuItem>
                <MenuItem value={"Uniform"}>Uniform</MenuItem>
                <MenuItem value={"Transportation"}>Transportation</MenuItem>
                <MenuItem value={"Meal"}>Meal</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={6} xl={7.6}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                {t("create")}
              </Button>

              <CreateSchoolFee
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        {loading ? (
          <Stack
            width="100%"
            justifyItems="center"
            bgcolor="#fff"
            borderRadius="5px"
          >
            <LoadingPage />
          </Stack>
        ) : (
          <>
            {tableData?.length === 0 ? (
              <Stack
                width="100%"
                justifyItems="center"
                bgcolor="#fff"
                borderRadius="5px"
              >
                <EmptyData />
              </Stack>
            ) : (
              <>
                <Grid container spacing={2}>
                  {tableData?.map((row, index) => {
                    return (
                      <Grid item key={index}>
                        <Box className="card-container">
                          <Stack direction="column" spacing={1}>
                            <Stack direction="column">
                              <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Typography className="cart-title">
                                  {row?.gradeName}
                                </Typography>
                                <SchoolFeeAction editData={row} />
                              </Stack>
                              <Typography className="card-discription">
                                {row?.type}
                              </Typography>
                            </Stack>

                            <Typography className="card-price">
                              Price
                            </Typography>
                            <Stack direction="row" spacing={4}>
                              {row?.prices?.map((row, index) => {
                                return (
                                  <Stack key={index} width="140px">
                                    <Box className="fee-card-container">
                                      {row?.discountPercentage ||
                                      row?.discountPrice ? (
                                        <Stack
                                          direction="column"
                                          className="title-container"
                                        >
                                          <Typography className="discount-title">
                                            {row?.discountPrice === 0
                                              ? `${row?.discountPercentage}%`
                                              : `$${row?.discountPrice}`}
                                          </Typography>
                                          <Typography
                                            className="discount-title"
                                            sx={{ marginTop: "-5px" }}
                                          >
                                            OFF
                                          </Typography>
                                        </Stack>
                                      ) : null}
                                      <Button className="btn-select-fee">
                                        <Stack direction="column" spacing={1}>
                                          <Typography
                                            className="fee-card-des"
                                            sx={{ fontWeight: "bold" }}
                                          >
                                            {row?.duration}{" "}
                                            {row?.duration === "1"
                                              ? "month"
                                              : "months"}
                                          </Typography>
                                          {row?.discountPrice ||
                                          row?.discountPercentage ? (
                                            <Typography
                                              className="fee-card-des-price"
                                              sx={{
                                                textDecoration: "line-through",
                                              }}
                                            >
                                              ${row?.price}
                                            </Typography>
                                          ) : (
                                            <Typography className="fee-card-des-price">
                                              ${row?.price}
                                            </Typography>
                                          )}
                                          {row?.discountPrice ||
                                          row?.discountPercentage ? (
                                            <Typography className="fee-card-des-price">
                                              ${" "}
                                              {Math.ceil(
                                                row?.discountPrice === 0
                                                  ? row?.price -
                                                      (row?.discountPercentage *
                                                        row?.price) /
                                                        100
                                                  : row?.price -
                                                      row?.discountPrice
                                              )}
                                            </Typography>
                                          ) : (
                                            ""
                                          )}
                                          {/* <Typography className="fee-card-des">
                                            Admin Fee
                                          </Typography>
                                          <Typography className="fee-card-des-box">
                                            $100/YEAR
                                          </Typography> */}
                                        </Stack>
                                      </Button>
                                    </Box>
                                  </Stack>
                                );
                              })}
                            </Stack>
                          </Stack>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </>
            )}
          </>
        )}

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
        />
      </Box>
    </div>
  );
}
